import ActionTypes from '../constants/ActionTypes';

/* Events */

export const createDeviceMembershipRequested = (data) => ({
  type: ActionTypes.DEVICE_MEMBERSHIP_CREATE_REQUESTED,
  payload: {
    data,
  },
});

export const createDeviceMembershipSucceeded = (deviceMembership) => ({
  type: ActionTypes.DEVICE_MEMBERSHIP_CREATE_SUCCEEDED,
  payload: {
    deviceMembership,
  },
});

export const createDeviceMembershipFailed = (error) => ({
  type: ActionTypes.DEVICE_MEMBERSHIP_CREATE_FAILED,
  payload: {
    error,
  },
});

export const createDeviceMembershipReceived = (deviceMembership) => ({
  type: ActionTypes.DEVICE_MEMBERSHIP_CREATE_RECEIVED,
  payload: {
    deviceMembership,
  },
});

export const deleteDeviceMembershipRequested = (deviceId, userId) => ({
  type: ActionTypes.DEVICE_MEMBERSHIP_DELETE_REQUESTED,
  payload: {
    deviceId,
    userId,
  },
});

export const deleteDeviceMembershipSucceeded = (deviceMembership) => ({
  type: ActionTypes.DEVICE_MEMBERSHIP_DELETE_SUCCEEDED,
  payload: {
    deviceMembership,
  },
});

export const deleteDeviceMembershipFailed = (deviceId, userId, error) => ({
  type: ActionTypes.DEVICE_MEMBERSHIP_DELETE_FAILED,
  payload: {
    deviceId,
    userId,
    error,
  },
});

export const deleteDeviceMembershipReceived = (deviceMembership) => ({
  type: ActionTypes.DEVICE_MEMBERSHIP_DELETE_RECEIVED,
  payload: {
    deviceMembership,
  },
});
